import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export const CandleVisual = () => {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [9, -9]), { stiffness: 140, damping: 18 });
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-11, 11]), { stiffness: 140, damping: 18 });

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => {
    mx.set(0);
    my.set(0);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 48, rotate: 2 }}
      animate={{ opacity: 1, y: 0, rotate: 0 }}
      transition={{ duration: 1.1, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
      style={{ perspective: 1000 }}
      className="w-full max-w-sm"
    >
      <motion.div
        ref={ref}
        data-testid="hero-candle-visual"
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        className="relative rounded-3xl bg-brandSand/60 border border-brandSand p-5 shadow-xl shadow-brandTerracotta/10 space-y-5"
      >
        <div className="relative w-full aspect-[4/5] rounded-t-[10rem] rounded-b-2xl overflow-hidden border border-amber-200/50">
          <img
            src="/images/scent-rose.webp"
            alt="Rose Marry — Enchanted Glim soy wax candle"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div
            aria-hidden
            className="absolute inset-0 bg-gradient-to-b from-amber-100/30 via-transparent to-brandDarkSlate/25"
          />
          <motion.div
            aria-hidden
            className="absolute -top-10 left-1/2 -translate-x-1/2 w-56 h-56 bg-amber-200/40 rounded-full blur-3xl"
            animate={{ scale: [1, 1.2, 1], opacity: [0.4, 0.65, 0.4] }}
            transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.span
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 1 }}
            className="absolute bottom-4 right-4 bg-brandCream/90 backdrop-blur-sm text-brandDarkSlate text-[10px] uppercase tracking-[0.2em] font-bold px-3 py-1.5 rounded-full"
          >
            45+ hr burn
          </motion.span>
        </div>
        <div className="text-center" style={{ transform: "translateZ(30px)" }}>
          <p className="font-serif font-bold text-xl">Rose Marry · 5-Inch Perforated Jar</p>
          <p className="text-xs text-brandDarkSlate/70 mt-1">100% Pure Soy &amp; Essential Botanical Oils</p>
        </div>
      </motion.div>
    </motion.div>
  );
};
